<template>
  <v-container fluid>
    <v-row align="center" justify="center" v-if="user">
      <v-col cols="12" sm="9" md="6">
        <v-card>
          <v-toolbar flat dark dense color="primary">
            <v-toolbar-title>
              {{ isMine ? 'My Profile' : `Profile for ${user.FirstName} ${user.LastName}` }}
            </v-toolbar-title>
          </v-toolbar>
          <v-tabs centered grow icons-and-text v-model="active">
            <v-tab>
              Account Settings
              <v-icon>person</v-icon>
            </v-tab>
            <v-tab v-if="isMine || $store.getters.can('Admin')">
              Password Settings
              <v-icon>lock</v-icon>
            </v-tab>
            <v-tab>
              Roles and Permissions
              <v-icon>verified_user</v-icon>
            </v-tab>
          </v-tabs>

          <v-tabs-items v-model="active">
            <v-tab-item>
              <v-card flat>
                <ChangeProfileForm v-bind="user" @snackbar="openSnackbar($event)" />
              </v-card>
            </v-tab-item>
            <v-tab-item v-if="isMine || $store.getters.can('Admin')">
              <v-card flat>
                <ChangePasswordForm @snackbar="openSnackbar($event)" />
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <ChangePermissionsForm :roles="user.RoleValues"
                                       :id="user.Id"
                                       :disabled="isMine || !$store.getters.can('Admin')"
                                       @snackbar="openSnackbar($event)" />
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-col>
    </v-row>
    <circular-progress v-else />
    <v-snackbar v-model="snackbar.show"
                :timeout="2000">
      {{ snackbar.msg }}
      <v-btn color="accent"
             text
             @click="snackbar.show = false">
        Close
      </v-btn>
    </v-snackbar>
    <v-dialog v-model="alert.show" max-width="350">
      <v-card>
        <v-card-title class="headline">{{ alert.heading }}</v-card-title>
        <v-card-text>{{ alert.msg }}</v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="accent"
                 text
                 @click="alert.show = false">
            Got It
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import Messages from '@/components/Mixins/Messages';

export default {
  name: 'UserProfile',
  mixins: [
    Messages,
  ],
  data() {
    return {
      user: null,
      active: null,
    };
  },
  computed: {
    isMine() {
      if (!this.$route.params.id) {
        return true;
      }
      return this.$route.params.id === this.$store.getters.user.id;
    },
  },
  async created() {
    const id = this.$route.params.id || this.$store.getters.user.id;
    const endpoint = this.isMine ? 'User/Me' : `User/${id}`;
    const response = await this.$store.dispatch('get', endpoint);
    this.user = response.data;
  },
  async mounted() {
    if (this.$route.query.code && !this.$store.getters.isConfirmed) {
      try {
        await this.$store.dispatch('post', {
          api: 'User/Confirm',
          data: { Token: this.$route.query.code },
        });
        await this.$store.dispatch('confirm');
        this.$set(this.user, 'IsConfirmed', true);
        this.openSnackbar('Your email has been confirmed!');
      } catch (e) {
        // Do nothing
      }
    }
    if (this.$route.query.error === 'unconfirmed' && !this.$store.getters.isConfirmed) {
      this.openAlert('Warning', 'You must confirm your email before proceeding');
    }
  },
};
</script>
